import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Diamond(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M7.181 4a1 1 0 00-.875.517L4.386 8h6.996l-2-4h-2.2zm4.437 0l2 4h2.014l-2-4h-2.014zm4.25 0l2 4h1.736l-1.911-3.481A1 1 0 0016.816 4h-.948zm-3.869 15.825L4.685 10h14.619l-7.305 9.825zM4.554 3.552A3 3 0 017.181 2h9.635a3 3 0 012.63 1.557l2.415 4.4a2 2 0 01-.148 2.155l-8.109 10.906a2 2 0 01-3.209.001l-8.12-10.906a2 2 0 01-.147-2.16l2.426-4.401z",
    clipRule: "evenodd"
  }));
}

export default Diamond;